import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("supplivo_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function errorMessage(e, fallback = "Something went wrong. Please try again.") {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (detail && typeof detail.message === "string") return detail.message;
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const gbp = (v, currency = "GBP") => {
  if (v === null || v === undefined || v === "" || Number.isNaN(Number(v))) return "—";
  try {
    const n = Number(v);
    // tiny per-item prices (£0.00399 a skewer) keep enough decimals to be meaningful instead of collapsing to £0.00
    const digits = n !== 0 && Math.abs(n) < 0.05 ? 5 : n !== 0 && Math.abs(n) < 1 ? 3 : 2;
    return new Intl.NumberFormat("en-GB", { style: "currency", currency, minimumFractionDigits: 2, maximumFractionDigits: digits }).format(n);
  } catch {
    return `£${Number(v).toFixed(2)}`;
  }
};

const UK_MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const ukDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
  if (Number.isNaN(d.getTime())) return iso;
  return `${d.getDate()} ${UK_MONTHS[d.getMonth()]} ${d.getFullYear()}`; // e.g. 18 Sep 2026 (browsers render "Sept" via Intl)
};

export const STATUS_LABEL = {
  uploaded: "Uploaded",
  processing: "Processing",
  needs_review: "Needs Review",
  confirmed: "Confirmed",
  statement: "Statement",
  failed: "Processing Failed",
};
